export const createWebForm = /* GraphQL */ `
  mutation CreateWebForm($input: CreateWebFormRequestInput!) {
    createWebForm(input: $input) {
      transactionId
    }
  }
`;
